import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AppTitleStrategy extends TitleStrategy {
  private readonly appName = 'Moneco Dashboard';

  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    const title = this.buildTitle(routerState);
    if (title) {
      this.setDynamicTitle(title);
    } else {
      this.title.setTitle(this.appName);
    }
  }

  setDynamicTitle(pageTitle: string): void {
    if (!pageTitle) {
      this.title.setTitle(this.appName);
      return;
    }
    if (pageTitle.endsWith(` | ${this.appName}`)) {
      this.title.setTitle(pageTitle);
    } else {
      this.title.setTitle(`${pageTitle} | ${this.appName}`);
    }
  }
}
